<template>
  <div class="app">
    <nav class="navbar">
      <div class="container">
        <router-link to="/" class="logo" @click="closeMobileMenu">
          <img src="/images/logo.png" alt="公司 LOGO" class="logo-image">
        </router-link>
        <button
          class="nav-toggle"
          type="button"
          :class="{ active: mobileMenuOpen }"
          :aria-expanded="mobileMenuOpen"
          aria-controls="main-navigation"
          :aria-label="mobileMenuOpen ? '关闭导航菜单' : '打开导航菜单'"
          @click="toggleMobileMenu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div id="main-navigation" class="nav-links" :class="{ open: mobileMenuOpen }">
          <router-link to="/" @click="closeMobileMenu">首页</router-link>
          <div class="dropdown" :class="{ 'mobile-open': mobileProductsOpen }">
            <div class="dropdown-trigger-row">
              <router-link to="/products" class="dropdown-trigger" @click="closeMobileMenu">
                产品
              </router-link>
              <button
                class="dropdown-toggle"
                type="button"
                :aria-expanded="mobileProductsOpen"
                :aria-label="mobileProductsOpen ? '收起产品分类' : '展开产品分类'"
                @click="toggleMobileProducts"
              >
                <span class="dropdown-arrow">▼</span>
              </button>
            </div>
            <div class="dropdown-menu">
              <router-link to="/products/server" @click="closeMobileMenu">浪潮X86服务器</router-link>
              <router-link to="/products/innovation" @click="closeMobileMenu">浪潮信创服务器</router-link>
              <router-link to="/products/storage" @click="closeMobileMenu">浪潮存储</router-link>
              <router-link to="/products/xsky" @click="closeMobileMenu">XSKY分布式存储</router-link>
              <router-link to="/products/lenovo" @click="closeMobileMenu">联想服务器</router-link>
            </div>
          </div>
          <router-link to="/solutions" @click="closeMobileMenu">解决方案</router-link>
          <router-link to="/services" @click="closeMobileMenu">服务</router-link>
          <router-link to="/about" @click="closeMobileMenu">关于我们</router-link>
          <router-link to="/contact" @click="closeMobileMenu">联系我们</router-link>
        </div>
      </div>
      <div v-if="mobileMenuOpen" class="menu-backdrop" @click="closeMobileMenu"></div>
    </nav>

    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>

    <footer class="footer">
      <div class="container">
        <p><img src="/images/beian.png" alt="备案图标" class="beian-icon">京公网安备11010802045567号   京ICP备2025115783号<br>
          &copy;2025 北京杰创诚通科技有限公司. 版权所有.</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      mobileMenuOpen: false,
      mobileProductsOpen: false
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleNavigationKeydown)
    window.addEventListener('resize', this.handleNavigationResize)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleNavigationKeydown)
    window.removeEventListener('resize', this.handleNavigationResize)
  },
  methods: {
    toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
      if (!this.mobileMenuOpen) {
        this.mobileProductsOpen = false
      }
    },
    toggleMobileProducts() {
      this.mobileProductsOpen = !this.mobileProductsOpen
    },
    closeMobileMenu() {
      this.mobileMenuOpen = false
      this.mobileProductsOpen = false
    },
    handleNavigationKeydown(event) {
      if (event.key === 'Escape') {
        this.closeMobileMenu()
      }
    },
    handleNavigationResize() {
      if (window.innerWidth > 768) {
        this.closeMobileMenu()
      }
    }
  }
}
</script>

<style>
:root {
  --primary-color: #2c3e50;
  --secondary-color: #3498db;
  --background-color: #f8f9fa;
  --text-color: #333;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', -apple-system, BlinkMacSystemFont, sans-serif;
  line-height: 1.6;
  color: var(--text-color);
  background-color: var(--background-color);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
}

.logo {
  text-decoration: none;
  background: white;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

.logo-image {
  height: 50px;
  width: auto;
  display: block;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-toggle {
  display: none;
}

.nav-links a {
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  transition: color 0.3s;
}

.nav-links a:hover {
  color: var(--secondary-color);
}

.footer {
  background: var(--primary-color);
  color: white;
  padding: 2rem 0;
  text-align: center;
  margin-top: 4rem;
}

.beian-icon {
  width: 1em;
  height: 1em;
  vertical-align: middle;
  margin-right: 0.3em;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-trigger-row {
  display: flex;
  align-items: center;
}

.dropdown-trigger {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  text-decoration: none;
  color: var(--text-color);
  font-weight: 500;
  transition: color 0.3s;
}

.dropdown-arrow {
  font-size: 0.8rem;
  display: block;
  transition: transform 0.3s ease;
}

.dropdown-toggle {
  border: 0;
  background: transparent;
  color: var(--text-color);
  padding-left: 0.3rem;
  pointer-events: none;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  min-width: 160px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  border-radius: 4px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s;
  z-index: 1000;
  padding: 0.5rem 0;
}

.dropdown:hover .dropdown-menu {
  opacity: 1;
  visibility: visible;
}

.dropdown-menu a {
  display: block;
  padding: 0.7rem 1.5rem;
  color: var(--text-color);
  text-decoration: none;
  transition: background-color 0.3s;
  text-align: center;
  white-space: nowrap;
}

.dropdown-menu a:hover {
  background-color: #f5f5f5;
  color: var(--secondary-color);
}

.menu-backdrop {
  display: none;
}

@media (max-width: 768px) {
  .navbar .container {
    position: relative;
    z-index: 3;
  }

  .logo {
    padding: 8px 0;
  }

  .logo-image {
    height: 44px;
    max-width: 220px;
  }

  .nav-toggle {
    width: 44px;
    height: 44px;
    border: 0;
    background: transparent;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
  }

  .nav-toggle span {
    width: 24px;
    height: 2px;
    background: var(--primary-color);
    border-radius: 2px;
    transition: transform 0.3s ease, opacity 0.3s ease;
  }

  .nav-toggle.active span:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
  }

  .nav-toggle.active span:nth-child(2) {
    opacity: 0;
  }

  .nav-toggle.active span:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
  }

  .nav-links {
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    gap: 0;
    max-height: 0;
    padding: 0 20px;
    overflow-y: auto;
    background: white;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
    opacity: 0;
    visibility: hidden;
    transition: max-height 0.35s ease, opacity 0.25s ease, padding 0.35s ease;
  }

  .nav-links.open {
    max-height: calc(100vh - 70px);
    padding-top: 0.5rem;
    padding-bottom: 1rem;
    opacity: 1;
    visibility: visible;
  }

  .nav-links > a,
  .dropdown-trigger {
    display: block;
    padding: 0.85rem 0;
    border-bottom: 1px solid #eee;
  }

  .dropdown {
    display: block;
    width: 100%;
  }

  .dropdown-trigger-row {
    border-bottom: 1px solid #eee;
  }

  .dropdown-trigger-row .dropdown-trigger {
    flex: 1;
    border-bottom: 0;
  }

  .dropdown-toggle {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0;
    cursor: pointer;
    pointer-events: auto;
  }

  .dropdown.mobile-open .dropdown-arrow {
    transform: rotate(180deg);
  }

  .dropdown-menu {
    position: static;
    min-width: 0;
    max-height: 0;
    padding: 0;
    overflow: hidden;
    background: #f7f9fb;
    border-radius: 0;
    box-shadow: none;
    opacity: 1;
    visibility: hidden;
    transform: none;
    transition: max-height 0.35s ease;
  }

  .dropdown:hover .dropdown-menu {
    opacity: 1;
    visibility: hidden;
  }

  .dropdown.mobile-open .dropdown-menu,
  .dropdown.mobile-open:hover .dropdown-menu {
    max-height: 320px;
    visibility: visible;
  }

  .dropdown-menu a {
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e8edf2;
  }

  .dropdown-menu a:last-child {
    border-bottom: 0;
  }

  .menu-backdrop {
    position: fixed;
    z-index: 2;
    top: 70px;
    right: 0;
    bottom: 0;
    left: 0;
    display: block;
    background: rgba(0, 0, 0, 0.28);
  }
}
</style>
